export default import.meta.ROLLUP_FILE_URL_yW_eMvu1QqHghXJHMLbBbg;